import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DiscordOAuthStateClass;
function DiscordOAuthState() {
  if (DiscordOAuthStateClass === VOID) {
    class $ {
      constructor(state, expiresAt) {
        this.h2l_1 = state;
        this.i2l_1 = expiresAt;
      }
      toString() {
        return 'DiscordOAuthState(state=' + this.h2l_1 + ', expiresAt=' + this.i2l_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.h2l_1);
        result = imul(result, 31) + getStringHashCode(this.i2l_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DiscordOAuthState()))
          return false;
        if (!(this.h2l_1 === other.h2l_1))
          return false;
        if (!(this.i2l_1 === other.i2l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DiscordOAuthState');
    DiscordOAuthStateClass = $;
  }
  return DiscordOAuthStateClass;
}
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var BeginDiscordOAuthCommandClass;
function BeginDiscordOAuthCommand() {
  if (BeginDiscordOAuthCommandClass === VOID) {
    class $ {
      constructor(partyId, challenge) {
        this.j2l_1 = partyId;
        this.k2l_1 = challenge;
      }
      toString() {
        return 'BeginDiscordOAuthCommand(partyId=' + this.j2l_1.toString() + ', challenge=' + this.k2l_1 + ')';
      }
      hashCode() {
        var result = this.j2l_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.k2l_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BeginDiscordOAuthCommand()))
          return false;
        if (!this.j2l_1.equals(other.j2l_1))
          return false;
        if (!(this.k2l_1 === other.k2l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'BeginDiscordOAuthCommand');
    BeginDiscordOAuthCommandClass = $;
  }
  return BeginDiscordOAuthCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher1zt6xwq01e9iu,
  BeginDiscordOAuthCommand as BeginDiscordOAuthCommandkbp00dnk4yho,
  DiscordOAuthState as DiscordOAuthState1jmuy0stlq7zq,
};
//endregion

//# sourceMappingURL=BeginDiscordOAuthCommand.mjs.map
